import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=6e386ae5&scoped=true"
import script from "./Notifications.ts?vue&type=script&lang=ts&external"
export * from "./Notifications.ts?vue&type=script&lang=ts&external"
import style0 from "./Notifications.scss?vue&type=style&index=0&id=6e386ae5&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e386ae5",
  null
  
)

export default component.exports